"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Spinner = function (props) {
    return ((0, preact_1.h)("div", { class: "signup-modal-ab-spin__spinner" },
        (0, preact_1.h)("div", { class: "signup-modal-ab-spin__spin-the-wheel", onAnimationEnd: function () { return setTimeout(props.onAnimationEnd, 800); } },
            (0, preact_1.h)("label", { class: "signup-modal-ab-spin__label" },
                (0, preact_1.h)("input", { class: "signup-modal-ab-spin__input", type: "radio" }),
                (0, preact_1.h)("img", { src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/spin-stopper.png?v=1686000843", class: "signup-modal-ab-spin__clicker" }),
                (0, preact_1.h)("img", { src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/spinner-20_-off.png?v=1704831308", class: "signup-modal-ab-spin__wheel" }))),
        (0, preact_1.h)("p", { class: "signup-modal-ab-spin__spin" }, "SPIN")));
};
exports.default = Spinner;
